(function(){
    'use strict';

    angular.module('Directives').directive('scrollableListCard', function(){
        return {
            restrict: 'E',
            scope: {
                bbaClass: '=?',
                marginTop: '=?',
                height: '=?',
                width: '=?',
                ngModel: '=',
                noDataMsg: '=?',
                withRemove: '=?',
                onClick:'=?',
                edit: '=?',
                remove: '=?',
                ngDisabled: '=?'
            },
            templateUrl: '/templates/directives/scrollable-list-card.html',
            link: scrollableListCard
        }

        function scrollableListCard($scope) {
            $scope.cssStyle = {
                'height' : `${$scope.height}px`
            } 
            $scope.cardsList = []; 
            $scope.$watch('ngModel', value=>{
                $scope.cardsList = value ? value.data : [];
            });

            $scope.$watch('cardsList', value=>{
                $scope.cardsList = value;
            })
            $scope.noDataMsg = $scope.noDataMsg ? $scope.noDataMsg : 'No Data found';
        }
    })
})()


// WEBPACK FOOTER //
// ./js/directives/scrollableListCard.js